module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABNgAAAABCAYAAAAMyBOIAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAAgSURBVFiF7cExAQAACAMg7Z9zOWYHb2CTdAAAAACAlwNwfwOwwj2UcgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/Shape.png
// module id = yKGj
// module chunks = 6